import { CurrentUser } from "sdk/currentUser";
import { useAppSelector } from "~/store/hooks";

export const useCurrentUser = (): CurrentUser | null => {
  return useAppSelector((state) => state.authentication.currentUser);
};
